class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
 
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      initDiscountForm();
    });
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

   (function () {
    var discountcode = `Black Friday Sale`;
    const CODE = (window.DISCOUNT_CODE || discountcode).trim();
    const POLL_TRIES = 6;
    const POLL_INTERVAL_MS = 250;

    if (!CODE) return;
    const getCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const codeInCart = (cart, code) => {
      if (!cart || !Array.isArray(cart.discount_codes)) return false;
      const want = code.toLowerCase();
      for (const dc of cart.discount_codes) {
        if (!dc) continue;
        const name = String(dc.code || '')
          .trim()
          .toLowerCase();
        const applied =
          dc.applied === true ||
          dc.applicable === true ||
          (typeof dc.applied === 'undefined' && typeof dc.applicable === 'undefined');
        if (name === want && applied) return true;
      }
      return false;
    };
    const applyDiscount = (code) =>
      fetch('/discount/' + encodeURIComponent(code) + '?ajax=1', { credentials: 'same-origin' }).catch(() => {
      });

    const pollForCode = (triesLeft, onOk, onFail) => {
      getCart()
        .then((cart) => {
          if (codeInCart(cart, CODE)) onOk();
          else if (triesLeft > 0) setTimeout(() => pollForCode(triesLeft - 1, onOk, onFail), POLL_INTERVAL_MS);
          else onFail();
        })
        .catch(onFail);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    function start() {
      getCart()
        .then((cart) => {
          if (codeInCart(cart, CODE)) return;
          applyDiscount(CODE).finally(() => {
            pollForCode(
              POLL_TRIES,
              () => {
              },
              () => {
                console.warn('Discount not applied:', CODE);
              }
            );
          });
        })
        .catch(() => {
          console.warn('Could not read cart to check discount.');
        });
    }
  })();
 
$(function(){
 initDiscountForm();
});

document.addEventListener('initDiscountForm', () => {
  initDiscountForm();  
})


function initDiscountForm(){


  


  $('.discount-msg').remove();
   var $box=$('.discount-box'),
      $maincartdrawer=$('.cart-drawer'),
      $form=$('#discountForm'),
      $field=$('.discount-box__field'),
      $input=$('#discount_code'),
      $button=$form.find('.discount-box__btn'),
      $buttonparent=$form.find('.button-container'),
      $msg=$('<div class="discount-msg"></div>').insertAfter($form),
      $cartDrawer=document.querySelector('cart-drawer'),
      LS_KEY='lastAppliedDiscountCode';

  function refreshSelectors(){
    $box=$('.discount-box');
    $maincartdrawer=$('.cart-drawer'),
    $form=$('#discountForm');
    $field=$('.discount-box__field');
    $input=$('#discount_code');
    $button=$form.find('.discount-box__btn');
    $msg=$('.discount-msg');
    if(!$msg.length){ $msg=$('<div class="discount-msg"></div>').insertAfter($form); }
  }

  function getCartSections(){
    return $.ajax({url:'/?sections=cart-drawer,cart-icon-bubble',dataType:'json'});
  }
  function getCartJSON(){ return $.getJSON('/cart.js'); }

  function codeInCart(cart, code){
    if(!cart||!code) return false;
    var want=String(code).trim().toLowerCase();

    if(Array.isArray(cart.discount_codes)){
      for(var i=0;i<cart.discount_codes.length;i++){
        var dc=cart.discount_codes[i];
        if(!dc) continue;
        var name=String(dc.code||'').trim().toLowerCase();
        var appliedFlag=(dc.applied===true)||(dc.applicable===true)||(typeof dc.applied==='undefined'&&typeof dc.applicable==='undefined');
        if(name===want && appliedFlag) return true;
      }
    }

    if(Array.isArray(cart.items)){
      for(var j=0;j<cart.items.length;j++){
        var it=cart.items[j];
        var allocs = [].concat(it.line_level_discount_allocations||[], it.discount_allocations||[]);
        for(var k=0;k<allocs.length;k++){
          var da=(allocs[k]&&allocs[k].discount_application)||allocs[k];
          if(da && da.type==='discount_code'){
            var title=String(da.title||'').trim().toLowerCase();
            if(title===want) return true;
          }
        }
      }
    }
    return false;
  }

  function firstAppliedCode(cart){
    if(cart && Array.isArray(cart.discount_codes) && cart.discount_codes.length){
      var dc=cart.discount_codes.find(function(d){return d&&(d.applied===true||d.applicable===true||typeof d.applied==='undefined');});
      if(dc && dc.code) return dc.code;
    }
    if(Array.isArray(cart.items)){
      for(var j=0;j<cart.items.length;j++){
        var it=cart.items[j];
        var allocs=[].concat(it.line_level_discount_allocations||[], it.discount_allocations||[]);
        var hit=allocs.find(function(a){var da=(a&&a.discount_application)||a; return da&&da.type==='discount_code'&&da.title;});
        if(hit){ var da=(hit.discount_application)||hit; return da.title||''; }
      }
    }
    return '';
  }

  function setError(text,keepValue){
    refreshSelectors();
    if(keepValue!=null) $input.val(keepValue);
    $field.addClass('is-error');
    $msg.text(text||'Der Rabattcode ist ungültig').show();
    $button.removeClass('is-success loading').text('Anwenden');
    $box.removeClass('locked');
    $input.prop('disabled',false);
    localStorage.removeItem(LS_KEY);
    $maincartdrawer.removeClass('coupon-applied');
    $buttonparent.removeClass('has-success');
  }

  function setApplied(code){
    refreshSelectors();
    $input.val((code||'').toUpperCase());
    $field.removeClass('is-error');
    $msg.hide();
    $maincartdrawer.addClass('coupon-applied');
    $buttonparent.addClass('has-success');
    $button.addClass('is-success').removeClass('loading').html(`
    <span class="success-discount-btn">
    <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align:middle;">
      <path d="M1.66634 7.0026C1.66634 4.05708 4.05415 1.66927 6.99967 1.66927C9.94521 1.66927 12.333 4.05708 12.333 7.0026C12.333 9.94814 9.94521 12.3359 6.99967 12.3359C4.05415 12.3359 1.66634 9.94814 1.66634 7.0026ZM6.99967 0.335938C3.31777 0.335938 0.333008 3.3207 0.333008 7.0026C0.333008 10.6845 3.31777 13.6693 6.99967 13.6693C10.6815 13.6693 13.6663 10.6845 13.6663 7.0026C13.6663 3.3207 10.6815 0.335938 6.99967 0.335938ZM10.6377 5.30734L9.69494 4.36453L6.33301 7.72647L4.47108 5.86454L3.52827 6.80734L6.33301 9.61207L10.6377 5.30734Z" fill="#77FFA4"/>
    </svg>
    <span>Rabatt aktiviert!</span>
  `);

    $box.addClass('locked');
    $input.prop('disabled',true);
    if(code) localStorage.setItem(LS_KEY,code);
    $("#remove_code").show();
  }

  function clearApplied(){
    refreshSelectors();
    $input.val('');
    $field.removeClass('is-error');
    $msg.hide();
    $button.removeClass('is-success loading').text('Anwenden');
    $maincartdrawer.removeClass('coupon-applied');
    $box.removeClass('locked');
    $input.prop('disabled',false);
    localStorage.removeItem(LS_KEY);
    $buttonparent.removeClass('has-success');
    $("#remove_code").show();
  }

       

     document.getElementById('remove_code').addEventListener('click', function () {
      const formData = new FormData();
      formData.append('discount', '');

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        getCartJSON().then(function(cart) {
          getCartSections().then(function(sectionData) {
            if ($cartDrawer && typeof $cartDrawer.renderContents === 'function') {
              $cartDrawer.renderContents({ sections: sectionData, id: null });
            }
            
            initDiscountForm();
          });
        });
      })
      .catch(error => {
        console.error('Error removing discount:', error);
      });
      clearApplied();
      this.style.display = 'none';
    });



  $form.on('submit', function(e){
      e.preventDefault();
      var code = $.trim($input.val());
      if(!code){ 
        setError('Bitte gib einen Rabattcode ein.', code);
        return;
      }

      $button.addClass('loading').prop('disabled', true).attr('aria-busy','true');
      const formData = new FormData();
      formData.append('discount', '');

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
          getCartJSON().then(function(cart){
            var currentCode = firstAppliedCode(cart);
            if(currentCode && currentCode.toLowerCase() !== code.toLowerCase()){
              
                return applyDiscount(code);
              
            } else {
              return applyDiscount(code);
            }
          });
      });
    });

    function applyDiscount(code){
      return $.get('/discount/' + encodeURIComponent(code) + '?ajax=1')
        .always(function(){
          getCartJSON().then(function(cart){
            if(!codeInCart(cart, code)){
              setError('Der Rabattcode ist ungültig', code);
              $button.prop('disabled', false).removeAttr('aria-busy');
              return;
            }
            getCartSections().then(function(sectionData){
              if($cartDrawer && typeof $cartDrawer.renderContents === 'function'){
                $cartDrawer.renderContents({ sections: sectionData, id: null });
              }
              setTimeout(function(){ setApplied(firstAppliedCode(cart) || code); }, 200);
              document.getElementById('remove_code').addEventListener('click', function() {
           clearApplied();
        });
            }).always(function(){
              $button.prop('disabled', false).removeAttr('aria-busy');
            });
          });
        });
    }


  $input.on('input change',function(){
    refreshSelectors();
    $field.removeClass('is-error');
    $msg.hide();
    console.log('hhkj '+ $input.val())
   if( $input.val() != ''){
    $("#remove_code").show();
   }
   else{
    $("#remove_code").hide();
   }
  });

  var savedCode=localStorage.getItem(LS_KEY);
  if(savedCode){
    getCartJSON().then(function(cart){
      if(codeInCart(cart,savedCode)){ setApplied(savedCode); } else {clearApplied();}
    });
  }
}
 
$(document).on('pageshow', function(event) {
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(cart => {
        
        const hasBlackFriday =
          Array.isArray(cart.discount_codes) &&
          cart.discount_codes.some(dc => dc.code?.toUpperCase() === 'BLACKFRIDAY');

        if (!hasBlackFriday) return; 

      
        const formData = new FormData();
        formData.append('discount', ''); 

        return fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
      })
      .then(res => {
        if (!res) return;
        return res.json();
      })
      .then(updatedCart => {
        if (!updatedCart) return;
        console.log('Discount removed. New cart:', updatedCart);
        // optional: refresh page or update cart UI here
        location.reload();
      })
      .catch(console.error);
});
 

 
